import { Box, Title, Text } from '@mantine/core';

export default function PricingHeroSection() {
  return (
    <Box
      py="xl"
      ta="center"
      style={{ background: 'linear-gradient(to bottom, #FFFFFF, #F1F7FF)' }}
    >
      <Title order={1} mb="sm">Simple, Pay-As-You-Go Pricing</Title>
      <Text>Browse for free. Pay only when you're ready to connect and collaborate.</Text>
    </Box>
  );
}